import React from "react";
import { getBucketIndexForValue } from "./utils";

const MiniDistribution = ({ distribution, patternMedian, compact }) => {
  if (!distribution?.length) return null;
  const bucketIndex = patternMedian != null ? getBucketIndexForValue(patternMedian, distribution) : null;

  const logHeights = distribution.map((b) => Math.log(b.count + 1));
  const maxLog = Math.max(...logHeights);
  const minLog = Math.min(...logHeights);
  const logRange = maxLog - minLog || 1;

  const sizeClass = compact ? "h-2.5 min-w-[32px]" : "h-3.5 min-w-[52px]";

  return (
    <div className={`relative flex items-end gap-px ${sizeClass}`}>
      {distribution.map((bucket, i) => {
        const logH = Math.log(bucket.count + 1);
        const heightPct = ((logH - minLog) / logRange) * 100;
        const isFilled = bucketIndex != null && i <= bucketIndex;
        const barTone = isFilled ? "bg-theme-text opacity-[0.48]" : "bg-theme-text opacity-[0.18]";

        return (
          <div
            key={i}
            className={`flex-1 rounded-sm transition-colors ${barTone}`}
            style={{ height: `${Math.max(heightPct, 12)}%` }}
          />
        );
      })}
    </div>
  );
};

export default MiniDistribution;
